import React, { useState } from 'react';
import { MdCancel } from "react-icons/md";
import logo from "../Header/Images/RMB-Strip-Jaipur.png";
import axios from 'axios';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useNavigate } from 'react-router-dom';
import { LiaEyeSlashSolid, LiaEyeSolid } from 'react-icons/lia';

const Login = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [show, setShow] = useState<Boolean>(true);
  const [error, setError] = useState<string>('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent page reload
  
    const formData = new FormData(e.target as HTMLFormElement);
  
    // Log form data to check what is being sent
    const data = {
      name: formData.get('name'),
      password: formData.get('password')
    };
    //console.log('Form data:', data);
  
    try {
      const response = await axios.post(`${api}/auth/login`, 
        data, { withCredentials: true });
    //console.log('Login successful:', response.data);
    // Redirect to dashboard
    window.location.href = response.data.dashboard;
    } catch (error: any) {
      // Handle error
      setError('Invalid credentials.');
      console.error('Login failed:', error);
    }
  };
  

  return (
    <div>
      <Header/>
     
      <div className=" flex items-center justify-center z-50 bg-[#E1E8F0] lg:p-10 sm:p-1 p-1"
         style={{
            // backgroundImage:`url(${bg})`,
            backgroundRepeat:'no-repeat',
            backgroundSize:'cover',
            backgroundPosition:'left center',
             
         }}
        >
          <div className="flex justify-center w-screen  h-[80vh] duration-1000">
            <div className=" w-[100%]  !z-[100] ">
              

              <div className="flex justify-center items-center h-[100%] flex-wrap p-2">
                
                <div className="flex justify-center shadow-2xl items-center  h-[100%] flex-col lg:w-[70%] w-[100%] bg-gradient-to-b from-darkblue to-[#0c3c7c]  rounded-3xl">
                  <h1 className="uppercase text-white text-5xl font-black pb-1">Welcome</h1>
                  <p className=" text-white text-base capitalize">login here to member dashboard</p>

                  <div className="p-6 rounded-lg lg:w-[60%] sm:w-[90%] w-[90%]">
                    {/* Display error message if any */}
                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}

                    <form onSubmit={handleLogin}>
                      <label className="block mb-2">
                        <input
                          type="text"
                          name="name"  // Added name attribute for FormData
                          className="w-full border p-2 rounded mt-4"
                          placeholder="Enter your username"
                          required
                        />
                      </label>
                      

                      <label className="block mb-2 relative">
                        <input
                            type={showPassword ? "text" : "password"}
                          name="password"  // Added name attribute for FormData
                          className="w-full border p-2 rounded mt-4"
                          placeholder="Enter your password"
                          required
                          
                        />
                        <div className="absolute top-[64%] right-3 transform -translate-y-1/2 cursor-pointer">
    {!showPassword ? (
      <LiaEyeSlashSolid onClick={() => setShowPassword(true)} /> // Show password icon
    ) : (
      <LiaEyeSolid onClick={() => setShowPassword(false)} /> // Hide password icon
    )}
  </div>
                      </label>
                      <button className="bg-textyellow rounded w-full  mt-6 text-darkblue font-[16px] h-[46px]" type="submit">
                        Login Now
                      </button>

                      
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     
      <Footer/>
    </div>
  );
};

export default Login;
